/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
interface PublicationsPageProps {
  themeMode: string
}

const PublicationsPage: FC<PublicationsPageProps> = ({ themeMode }) => (
  <>
    <div className="card h-100">
      <div className="card-body">
        <div className="d-flex flex-column justify-content-center align-items-center gap-5 mb-6 h-100">
          <img
            src={`/media/logos/vampp-logo-${themeMode === 'light' ? 'dark' : 'white'}.png`}
            alt="logo"
            width={300}
            className="logo"
          />
          <ul>
            <li className=" fs-5  text-justify">
              Ozdemir, O., Bychkovsky, B. L., Unal, B., Onder, G., Amanvermez, U., Aydin, E., Ergun, B., Sahin, I., Gokbayrak, M., Ugurtas, C., Koroglu, M. N., Cakir, B., Kalay, I., Cine, N., Ozbek, U., Rana, H. Q., Hatirnaz Ng, O., & Agaoglu, N. B. (2024). Molecular and In Silico Analysis of the CHEK2 Gene in Individuals with High Risk of Cancer Predisposition from Türkiye. <i>Cancers, 16(22), 3876.</i> DOI:{" "}
              <a href="https://doi.org/10.3390/cancers16223876" rel="noreferrer" target="_blank">
                https://doi.org/10.3390/cancers16223876
              </a>
            </li>
            <li className=" fs-5  mt-4 text-justify">
              <b>If you use VAMPP-score or any component of our statistical framework in your work, please cite us:</b><br />
              A New Era in Missense Variant Analysis: Statistical Insights and the Introduction of VAMPP-Score for Pathogenicity Assessment
              Eylul Aydin, Berk Ergun, Ozlem Akgun-Dogan, Yasemin Alanay, Ozden Hatirnaz Ng, Ozkan Ozdemir
              <i>bioRxiv</i> (2024.07.11.602867). DOI:{" "}
              <a href="https://doi.org/10.1101/2024.07.11.602867" rel="noreferrer" target="_blank">
                https://doi.org/10.1101/2024.07.11.602867
              </a>
            </li>
          </ul>



        </div>

      </div>
    </div>
  </>
)

const PublicationsPageWrapper: FC = () => {
  const [themeMode, setThemeMode] = useState<string>('light')

  useEffect(() => {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme')
    setThemeMode(currentTheme === 'light' ? 'light' : 'dark')

    const observer = new MutationObserver(() => {
      const updatedTheme = document.documentElement.getAttribute('data-bs-theme')
      setThemeMode(updatedTheme === 'light' ? 'light' : 'dark')
    })

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] })

    return () => observer.disconnect()
  }, [])
  const sampleData = [
    { category: "A", value: 10 },
    { category: "A", value: 15 },
    { category: "B", value: 20 },
    { category: "B", value: 25 },
    { category: "C", value: 30 },
    { category: "C", value: 35 },
  ];
  return (
    <>
      <PublicationsPage themeMode={themeMode} />
    </>
  )
}

export { PublicationsPageWrapper }
